/**
 * Series Page.
 */
import MainTemplate from '@components/templates/main/ui/main';
import useSection from '@shared/components/utils/hooks/useSection';
import { QuerySections } from '@shared/types/enums/sections';

/**
 * Series page component that displays series content with highlights and reels.
 * Starts navigation in menu position.
 */
export default function SeriesPage() {
  const { complete, highlights, reels, onPagination } = useSection({
    section: QuerySections.SERIES,
  });
  return (
    <MainTemplate
      flags={{ complete }}
      rails={reels}
      sliders={highlights}
      onPagination={onPagination}
    />
  );
}
